const templates = [
    {
     id: 'caaaaaption',
      condition: `true`, // No condition
      template: `<span><<name>></span>`,
      expressions: {
        name: `doorData.frameData.name`
      },
      active: true,
      orderPlace: 1,
    },
    {
    id: 'hell',
      condition: `false`, // No condition
      template: `<span style="font-size:14px;">✔  Hell <<name>>,--<<aaa>>--,<<bbb>>! </span>`,
      expressions: {
        name: `doorData.frameData.name`,
        aaa: `doorData.frameData.square1`,       
        bbb: `doorData.frameData.type1` 
      },
      active: true,
      orderPlace: 2,
    },
    {
    id: 'MainRow',
    condition: `true`, // No condition
    template: `<span style="font-size:14px;">✔  <b>Main</b> Row: (f)</span>`,
    expressions: {
      name: `doorData.frameData.name`
    },
    active: true,
    orderPlace: 2,
  },
    {
      id: 'w1',
        condition: `doorData.frameData.nSections >= 1 && doorData && doorData.frameData && doorData.frameData.type1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>1.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.type1`,
          nameHTML: `doorData.frameData.type1 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.type1`,
          x: `doorData.frameData.windowWidth1`,
          y: `doorData.frameData.windowHeight`,
          square: `doorData.frameData.square1`
        },
        active: true,
        orderPlace: 3,
    }, 
    {
      id: 'w1_Casement',
      condition: `doorData.frameData.nSections >= 1 && 
                  doorData && doorData.frameData && 
                  doorData.frameData.type1 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hinges1`,
      },
      active: true,
      orderPlace: 3,
    }, 
    {
      id: 'w1_Slider',
      condition: `doorData.frameData.nSections >= 1 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type1 === 'Single Slider Tilt' ||
                  doorData.frameData.type1 === 'End-Vent'           ||
                  doorData.frameData.type1 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.slider1`,
      },
      active: true,
      orderPlace: 3,
    }, 
    {
      id: 'w1_TiltTurn',
      condition: `doorData.frameData.nSections >= 1 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type1 === 'Single Hung Tilt' ||
                  doorData.frameData.type1 === 'Double Hung Tilt' ||
                  doorData.frameData.type1 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurn1`,
      },
      active: true,
      orderPlace: 3,
    }, 
    {
      id: 'w1_grills',
        condition: `false && doorData.frameData.nSections >= 1 && 
                    doorData.grills.grillType1 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type1 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grills - Type: <<grillType>>, Size: <<grillSize>>, Pattern: <<grillPattern>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType1`,
          grillSize: `doorData.grills.grillsSize1`,
          grillPattern: `doorData.grills.grillsPattern1.label`,
        },
        active: true,
        orderPlace: 3,
    },  
    {
      id: 'w1_grillType',
        condition: `doorData.frameData.nSections >= 1 && 
                    doorData.grills.grillType1 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type1 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<grillType>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType1`,
        },
        active: true,
        orderPlace: 3,
    },  
    {
      id: 'w1_grillSize',
        condition: `doorData.frameData.nSections >= 1 && 
                    doorData.grills.grillType1 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type1 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<grillSize>></span>`,
        expressions: {
          grillSize: `doorData.grills.grillsSize1`,
        },
        active: true,
        orderPlace: 3,
    },  
    {
      id: 'w1_grillPattern',
        condition: `doorData.frameData.nSections >= 1 && 
                    doorData.grills.grillType1 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type1 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<grillPattern>></span>`,
        expressions: {
          grillPattern: `doorData.grills.grillsPattern1.label`,
        },
        active: true,
        orderPlace: 3,
    },  
    {
      id: 'w1_grillLines',
      condition: `doorData.frameData.nSections >= 1 && 
                  doorData.grills.grillType1 !== 'None' &&
                  doorData.grills.grillsPattern1.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.type1 !== undefined`,
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<hor>>, Vertical: <<ver>></span>`,
        expressions: {
          hor: `doorData.grills.glassDividersHorizontal1`,
          ver: `doorData.grills.glassDividersVertical1`,
        },
        active: true,
        orderPlace: 3,
    },  
    {
    id: 'w2',
      condition: `doorData.frameData.nSections >= 2 && doorData && doorData.frameData && doorData.frameData.type2 !== undefined`, 
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>2.</b> <<nameHTML>> <<x>>x<<y>></span>`,
      expressions: {
        name: `doorData.frameData.type2`,
        nameHTML: `doorData.frameData.type2 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.type2`,
        x: `doorData.frameData.windowWidth2`,
        y: `doorData.frameData.windowHeight`,
      },
      active: true,
      orderPlace: 4,
    },
    {
      id: 'w2_Casement',
      condition: `doorData.frameData.nSections >= 2 && doorData && doorData.frameData && doorData.frameData.type2 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hinges2`,
      },
      active: true,
      orderPlace: 4,
    }, 
    {
      id: 'w2_Slider',
      condition: `doorData.frameData.nSections >= 2 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type2 === 'Single Slider Tilt' ||
                  doorData.frameData.type2 === 'End-Vent'           ||
                  doorData.frameData.type2 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.slider2`,
      },
      active: true,
      orderPlace: 4,
    }, 
    {
      id: 'w2_TiltTurn',
      condition: `doorData.frameData.nSections >= 2 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type2 === 'Single Hung Tilt' ||
                  doorData.frameData.type2 === 'Double Hung Tilt' ||
                  doorData.frameData.type2 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurn2`,
      },
      active: true,
      orderPlace: 4,
    }, 
    {
      id: 'w2_grillType',
        condition: `doorData.frameData.nSections >= 2 && 
                    doorData.grills.grillType2 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type2 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<grillType>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType2`,
        },
        active: true,
        orderPlace: 4,
    },  
    {
      id: 'w2_grillSize',
        condition: `doorData.frameData.nSections >= 2 && 
                    doorData.grills.grillType2 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type2 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<grillSize>></span>`,
        expressions: {
          grillSize: `doorData.grills.grillsSize2`,
        },
        active: true,
        orderPlace: 4,
    },  
    {
      id: 'w2_grillPattern',
        condition: `doorData.frameData.nSections >= 2 && 
                    doorData.grills.grillType2 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type2 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<grillPattern>></span>`,
        expressions: {
          grillPattern: `doorData.grills.grillsPattern2.label`,
        },
        active: true,
        orderPlace: 4,
    },  
    {
      id: 'w2_grillLines',
      condition: `doorData.frameData.nSections >= 2 && 
                  doorData.grills.grillType2 !== 'None' &&
                  doorData.grills.grillsPattern2.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.type2 !== undefined`,
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<hor>>, Vertical: <<ver>></span>`,
        expressions: {
          hor: `doorData.grills.glassDividersHorizontal2`,
          ver: `doorData.grills.glassDividersVertical2`,
        },
        active: true,
        orderPlace: 4,
    },  

    {
      id: 'w3',
        condition: `doorData.frameData.nSections >= 3 &&  doorData && doorData.frameData && doorData.frameData.type3 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>3.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.type3`,
          nameHTML: `doorData.frameData.type3 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.type3`,
          x: `doorData.frameData.windowWidth3`,
          y: `doorData.frameData.windowHeight`,
        },
        active: true,
        orderPlace: 5,
    },
    {
      id: 'w3_Casement',
      condition: `doorData.frameData.nSections >= 1 && doorData && doorData.frameData && doorData.frameData.type3 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hinges3`,
      },
      active: true,
      orderPlace: 5,
    }, 
    {
      id: 'w3_Slider',
      condition: `doorData.frameData.nSections >= 3 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type3 === 'Single Slider Tilt' ||
                  doorData.frameData.type3 === 'End-Vent'           ||
                  doorData.frameData.type3 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.slider3`,
      },
      active: true,
      orderPlace: 5,
    }, 
    {
      id: 'w3_TiltTurn',
      condition: `doorData.frameData.nSections >= 3 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type3 === 'Single Hung Tilt' ||
                  doorData.frameData.type3 === 'Double Hung Tilt' ||
                  doorData.frameData.type3 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurn1`,
      },
      active: true,
      orderPlace: 5,
    }, 
    {
      id: 'w3_grillType',
        condition: `doorData.frameData.nSections >= 3 && 
                    doorData.grills.grillType3 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type3 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<grillType>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType3`,
        },
        active: true,
        orderPlace: 5,
    },  
    {
      id: 'w3_grillSize',
        condition: `doorData.frameData.nSections >= 3 && 
                    doorData.grills.grillType3 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type3 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<grillSize>></span>`,
        expressions: {
          grillSize: `doorData.grills.grillsSize3`,
        },
        active: true,
        orderPlace: 5,
    },  
    {
      id: 'w3_grillPattern',
        condition: `doorData.frameData.nSections >= 3 && 
                    doorData.grills.grillType3 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type3 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<grillPattern>></span>`,
        expressions: {
          grillPattern: `doorData.grills.grillsPattern3.label`,
        },
        active: true,
        orderPlace: 5,
    },  
    {
      id: 'w3_grillLines',
      condition: `doorData.frameData.nSections >= 3 && 
                  doorData.grills.grillType3 !== 'None' &&
                  doorData.grills.grillsPattern3.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.type3 !== undefined`,
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<hor>>, Vertical: <<ver>></span>`,
        expressions: {
          hor: `doorData.grills.glassDividersHorizontal3`,
          ver: `doorData.grills.glassDividersVertical3`,
        },
        active: true,
        orderPlace: 5,
    },  

    {
    id: 'w4',
      condition: `doorData.frameData.nSections >= 4  && doorData && doorData.frameData && doorData.frameData.type4 !== undefined`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>4.</b> <<nameHTML>> <<x>>x<<y>></span>`,
      expressions: {
        name: `doorData.frameData.type4`,
        nameHTML: `doorData.frameData.type4 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.type4`,
        x: `doorData.frameData.windowWidth4`,
        y: `doorData.frameData.windowHeight`,
      },
      active: true,
      orderPlace: 6,
    },
    {
      id: 'w4_Casement',
      condition: `doorData.frameData.nSections >= 1 && doorData && doorData.frameData && doorData.frameData.type4 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hinges4`,
      },
      active: true,
      orderPlace: 6,
    }, 
    {
      id: 'w4_Slider',
      condition: `doorData.frameData.nSections >= 4 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type4 === 'Single Slider Tilt' ||
                  doorData.frameData.type4 === 'End-Vent'           ||
                  doorData.frameData.type4 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.slider4`,
      },
      active: true,
      orderPlace: 6,
    }, 
    {
      id: 'w4_TiltTurn',
      condition: `doorData.frameData.nSections >= 4 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type4 === 'Single Hung Tilt' ||
                  doorData.frameData.type4 === 'Double Hung Tilt' ||
                  doorData.frameData.type4 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurn4`,
      },
      active: true,
      orderPlace: 6,
    }, 
    {
      id: 'w4_grillType',
        condition: `doorData.frameData.nSections >= 4 && 
                    doorData.grills.grillType4 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type4 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<grillType>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType4`,
        },
        active: true,
        orderPlace: 6,
    },  
    {
      id: 'w4_grillSize',
        condition: `doorData.frameData.nSections >= 4 && 
                    doorData.grills.grillType4 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type4 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<grillSize>></span>`,
        expressions: {
          grillSize: `doorData.grills.grillsSize4`,
        },
        active: true,
        orderPlace: 6,
    },  
    {
      id: 'w4_grillPattern',
        condition: `doorData.frameData.nSections >= 4 && 
                    doorData.grills.grillType4 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type4 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<grillPattern>></span>`,
        expressions: {
          grillPattern: `doorData.grills.grillsPattern4.label`,
        },
        active: true,
        orderPlace: 6,
    },  
    {
      id: 'w4_grillLines',
      condition: `doorData.frameData.nSections >= 4 && 
                  doorData.grills.grillType4 !== 'None' &&
                  doorData.grills.grillsPattern4.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.type4 !== undefined`,
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<hor>>, Vertical: <<ver>></span>`,
        expressions: {
          hor: `doorData.grills.glassDividersHorizontal4`,
          ver: `doorData.grills.glassDividersVertical4`,
        },
        active: true,
        orderPlace: 6,
    },  

    {
      id: 'w5',
        condition: `doorData.frameData.nSections >= 5 && doorData && doorData.frameData && doorData.frameData.type5 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>5.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.type5`,
          nameHTML: `doorData.frameData.type5 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.type5`,
          x: `doorData.frameData.windowWidth5`,
          y: `doorData.frameData.windowHeight`,
        },
        active: true,
        orderPlace: 7,
    },
    {
      id: 'w5_Casement',
      condition: `doorData.frameData.nSections >= 1 && doorData && doorData.frameData && doorData.frameData.type5 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hinges5`,
      },
      active: true,
      orderPlace: 7,
    }, 
    {
      id: 'w5_Slider',
      condition: `doorData.frameData.nSections >= 5 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type5 === 'Single Slider Tilt' ||
                  doorData.frameData.type5 === 'End-Vent'           ||
                  doorData.frameData.type5 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.slider5`,
      },
      active: true,
      orderPlace: 7,
    }, 
    {
      id: 'w5_TiltTurn',
      condition: `doorData.frameData.nSections >= 5 && 
                  doorData && doorData.frameData && 
                 (doorData.frameData.type5 === 'Single Hung Tilt' ||
                  doorData.frameData.type5 === 'Double Hung Tilt' ||
                  doorData.frameData.type5 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurn5`,
      },
      active: true,
      orderPlace: 7,
    }, 
    {
      id: 'w5_grillType',
        condition: `doorData.frameData.nSections >= 5 && 
                    doorData.grills.grillType5 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type5 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<grillType>></span>`,
        expressions: {
          grillType: `doorData.grills.grillType5`,
        },
        active: true,
        orderPlace: 7,
    },  
    {
      id: 'w5_grillSize',
        condition: `doorData.frameData.nSections >= 5 && 
                    doorData.grills.grillType5 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type5 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<grillSize>></span>`,
        expressions: {
          grillSize: `doorData.grills.grillsSize5`,
        },
        active: true,
        orderPlace: 7,
    },  
    {
      id: 'w5_grillPattern',
        condition: `doorData.frameData.nSections >= 5 && 
                    doorData.grills.grillType1 !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.type5 !== undefined`, 
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<grillPattern>></span>`,
        expressions: {
          grillPattern: `doorData.grills.grillsPattern5.label`,
        },
        active: true,
        orderPlace: 7,
    },  
    {
      id: 'w5_grillLines',
      condition: `doorData.frameData.nSections >= 5 && 
                  doorData.grills.grillType5 !== 'None' &&
                  doorData.grills.grillsPattern5.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.type5 !== undefined`,
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<hor>>, Vertical: <<ver>></span>`,
        expressions: {
          hor: `doorData.grills.glassDividersHorizontal5`,
          ver: `doorData.grills.glassDividersVertical5`,
        },
        active: true,
        orderPlace: 7,
    },  

    {
      id: 'TopRow',
      condition: `doorData.frameData.topRowConf !== "None"`, // No condition
      template: `<span style="font-size:14px;">✔  <b>Top</b> Row:</span>`,
      expressions: {
        name: `doorData.frameData.name`
      },
      active: true,
      orderPlace: 50,
    },
    {
      id: 'topArch',
        condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                    doorData.frameData.nSections >= 1 && 
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ Arch Window, <<x>>x<<y>>, leg Height:<<legHeight>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop1`,
          x: `doorData?.frameData?.mainRowWidth`,
          y: `doorData.frameData.uHeight`,
          legHeight: `doorData.frameData.archLegHeight`,
        },
        active: true,
        orderPlace: 50,
    },    
    {
      id: 'archGrillType',
        condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                    doorData.frameData.nSections >= 1 && 
                    doorData.grills.archGrillType !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Type: <<archGrillType>></span>`,
        expressions: {
          archGrillType: `doorData.grills.archGrillType`,
        },
        active: true,
        orderPlace: 50,
    },  
    {
      id: 'archGrillSize',
        condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                    doorData.frameData.nSections >= 1 && 
                    doorData.grills.archGrillType !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Size: <<archGrillSize>></span>`,
        expressions: {
          archGrillSize: `doorData.grills.archGrillSize`,
        },
        active: true,
        orderPlace: 50,
    },   
    { 
        id: 'archGrillPattern',
        condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                    doorData.frameData.nSections >= 1 && 
                    doorData.grills.archGrillType !== 'None' &&
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Grill Pattern: <<archGrillPattern>></span>`,
        expressions: {
          archGrillPattern: `doorData.grills.archGrillPattern.label`,
        },
        active: true,
        orderPlace: 50,
    },  
    { 
      id: 'archGrillLinesColonial',
      condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                  doorData.frameData.nSections >= 1 && 
                  doorData.grills.archGrillType !== 'None' &&
                  doorData.grills.archGrillPattern.value === 'Colonial' &&
                  doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Horizontal: <<archHorizontalGrills>>, Vertical: <<archVerticalGrills>></span>`,
      expressions: {
        archHorizontalGrills: `doorData.grills.archHorizontalGrills`,
        archVerticalGrills: `doorData.grills.archVerticalGrills`,
      },
      active: true,
      orderPlace: 50,
    },    
    { 
      id: 'archGrillLinesRays',
      condition: `(doorData.frameData.topRowConf === "Arch" || doorData.frameData.topRowConf === "ArchBar") &&
                  doorData.frameData.nSections >= 1 && 
                  doorData.grills.archGrillType !== 'None' &&
                  doorData.grills.archGrillPattern.value === 'Rays' &&
                  doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Number of rays: <<archRaysGrills>></span>`,
      expressions: {
        archRaysGrills: `doorData.grills.archRaysGrills`,
      },
      active: true,
      orderPlace: 50,
    },     
    {
      id: 'top1_1',
        condition: `doorData.frameData.topRowConf === "1" &&
                    doorData.frameData.nSections >= 1 && 
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>1.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop1`,
          nameHTML: `doorData.frameData.typeTop1 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop1`,
          x: `doorData?.frameData?.mainRowWidth`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 51,
    },    
    {
      id: 'top1',
        condition: `doorData.frameData.topRowConf === "Grid" &&
                    doorData.frameData.nSections >= 1 && 
                    doorData && doorData.frameData && doorData.frameData.typeTop1 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>1.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop1`,
          nameHTML: `doorData.frameData.typeTop1 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop1`,
          x: `doorData.frameData.windowWidth1`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 51,
    },    
    {
      id: 'top1_Casement',
      condition: `(doorData.frameData.topRowConf === "1" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 1 && 
                  doorData && doorData.frameData && 
                  doorData.frameData.typeTop1 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hingesTop1`,
      },
      active: true,
      orderPlace: 51,
    },     
    {
      id: 'top1_Slider',
      condition: `(doorData.frameData.topRowConf === "1" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 1 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop1 === 'Single Slider Tilt' ||
                   doorData.frameData.typeTop1 === 'End-Vent'           ||
                   doorData.frameData.typeTop1 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.sliderTop1`,
      },
      active: true,
      orderPlace: 51,
    }, 
    {
      id: 'top1_TiltTurn',
      condition: `(doorData.frameData.topRowConf === "1" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 1 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop1 === 'Single Hung Tilt' ||
                   doorData.frameData.typeTop1 === 'Double Hung Tilt' ||
                   doorData.frameData.typeTop1 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurnTop1`,
      },
      active: true,
      orderPlace: 51,
    }, 
    {
      id: 'top2',
        condition: `doorData.frameData.topRowConf === "Grid" &&
                    doorData.frameData.nSections >= 2 && 
                    doorData && doorData.frameData && 
                    doorData.frameData.typeTop2 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>2.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop2`,
          nameHTML: `doorData.frameData.typeTop2 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop2`,
          x: `doorData.frameData.windowWidth2`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 52,
    }, 
    {
      id: 'top2_Casement',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 2 && 
                   doorData && doorData.frameData && 
                   doorData.frameData.typeTop2 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hingesTop2`,
      },
      active: true,
      orderPlace: 52,
    }, 
    {
      id: 'top2_Slider',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 2 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop2 === 'Single Slider Tilt' ||
                   doorData.frameData.typeTop2 === 'End-Vent'           ||
                   doorData.frameData.typeTop2 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.sliderTop2`,
      },
      active: true,
      orderPlace: 52,
    },
    {
      id: 'top2_TiltTurn',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 2 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop2 === 'Single Hung Tilt' ||
                   doorData.frameData.typeTop2 === 'Double Hung Tilt' ||
                   doorData.frameData.typeTop2 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurnTop2`,
      },
      active: true,
      orderPlace: 52,
    }, 
    {
      id: 'top3',
        condition: `doorData.frameData.topRowConf === "Grid" &&
                    doorData.frameData.nSections >= 3 && 
                    doorData && doorData.frameData && 
                    doorData.frameData.typeTop3 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>3.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop3`,
          nameHTML: `doorData.frameData.typeTop3 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop3`,
          x: `doorData.frameData.windowWidth3`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 53,
    },  
    {
      id: 'top3_Casement',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 3 && 
                  doorData && doorData.frameData && 
                  doorData.frameData.typeTop3 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hingesTop3`,
      },
      active: true,
      orderPlace: 53,
    }, 
    {
      id: 'top3_Slider',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 3 && 
                  doorData && doorData.frameData && 
                  (doorData.frameData.typeTop3 === 'Single Slider Tilt' ||
                   doorData.frameData.typeTop3 === 'End-Vent'           ||
                   doorData.frameData.typeTop3 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.sliderTop3`,
      },
      active: true,
      orderPlace: 53,
    },
    {
      id: 'top3_TiltTurn',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 3 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop3 === 'Single Hung Tilt' ||
                   doorData.frameData.typeTop3 === 'Double Hung Tilt' ||
                   doorData.frameData.typeTop3 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurnTop3`,
      },
      active: true,
      orderPlace: 53,
    }, 
    {
      id: 'top4',
        condition: `doorData.frameData.topRowConf === "Grid" &&
                    doorData.frameData.nSections >= 4 && 
                    doorData && doorData.frameData && doorData.frameData.typeTop4 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>4.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop4`,
          nameHTML: `doorData.frameData.typeTop4 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop4`,
          x: `doorData.frameData.windowWidth4`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 54,
    },  
    {
      id: 'top4_Casement',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 4 && 
                  doorData && doorData.frameData && 
                  doorData.frameData.typeTop4 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hingesTop4`,
      },
      active: true,
      orderPlace: 54,
    }, 
    {
      id: 'top4_Slider',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 4 && 
                  doorData && doorData.frameData && 
                  (doorData.frameData.typeTop4 === 'Single Slider Tilt' ||
                   doorData.frameData.typeTop4 === 'End-Vent'           ||
                   doorData.frameData.typeTop4 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.sliderTop4`,
      },
      active: true,
      orderPlace: 54,
    },
    {
      id: 'top4_TiltTurn',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 4 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop4 === 'Single Hung Tilt' ||
                   doorData.frameData.typeTop4 === 'Double Hung Tilt' ||
                   doorData.frameData.typeTop4 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurnTop4`,
      },
      active: true,
      orderPlace: 54,
    }, 
    {
      id: 'top5',
        condition: `doorData.frameData.topRowConf === "Grid" &&
                    doorData.frameData.nSections >= 5 && 
                    doorData && doorData.frameData && doorData.frameData.typeTop5 !== undefined`, // No condition
        template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;✔ <b>5.</b> <<nameHTML>> <<x>>x<<y>></span>`,
        expressions: {
          name: `doorData.frameData.typeTop5`,
          nameHTML: `doorData.frameData.typeTop5 === "None" ? '<span style="color:red;">None</span>' : doorData.frameData.typeTop5`,
          x: `doorData.frameData.windowWidth5`,
          y: `doorData.frameData.uHeight`,
        },
        active: true,
        orderPlace: 55,
    }, 
    {
      id: 'top5_Casement',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 5 && 
                  doorData && doorData.frameData && 
                  doorData.frameData.typeTop5 === 'Casement'`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Hinges: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.hingesTop5`,
      },
      active: true,
      orderPlace: 55,
    },  
    {
      id: 'top5_Slider',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                  doorData.frameData.nSections >= 5 && 
                  doorData && doorData.frameData && 
                  (doorData.frameData.typeTop5 === 'Single Slider Tilt' ||
                   doorData.frameData.typeTop5 === 'End-Vent'           ||
                   doorData.frameData.typeTop5 === 'Double Slider Tilt')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Slider option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.sliderTop5`,
      },
      active: true,
      orderPlace: 55,
    },
    {
      id: 'top5_TiltTurn',
      condition: `(doorData.frameData.topRowConf === "stub" || doorData.frameData.topRowConf === "Grid") &&
                   doorData.frameData.nSections >= 5 && 
                   doorData && doorData.frameData && 
                  (doorData.frameData.typeTop5 === 'Single Hung Tilt' ||
                   doorData.frameData.typeTop5 === 'Double Hung Tilt' ||
                   doorData.frameData.typeTop5 === 'Tilt and Turn')`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; • Tilt and Turn option: <<name>></span>`,
      expressions: {
        name: `doorData.frameData.tiltAndTurnTop5`,
      },
      active: true,
      orderPlace: 55,
    }, 
    {
      id: 'Glass',
      condition: `true`, // No condition
      template: `<span style="font-size:14px;">✔  <b>Glass</b>:</span>`,
      expressions: {
        name: `doorData.frameData.name`
      },
      active: true,
      orderPlace: 70,
    },
    {
      id: 'GlassType',
      condition: `true`, // No condition
      template: `<span style="font-size:14px;">✔ Type: <<name>></span>`,
      expressions: {
        name: `doorData.glass.glassType1.label`
      },
      active: true,
      orderPlace: 71,
    },
    {
      id: 'TexturedDesign',
      condition2: `true`,
      condition: `doorData && (doorData.glass.glassType1.label === 'Textured')`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Textured design: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.texturedDesign1`
      },
      active: true,
      orderPlace: 72,
    },
    {
      id: 'TintedDesign',
      condition2: `true`,
      condition: `doorData && (doorData.glass.glassType1.label === 'Tinted')`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Tinted design: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.tintedDesign1`
      },
      active: true,
      orderPlace: 73,
    },
    {
      id: 'GlazingType',
      condition: `true`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Glazing type: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.glazingType1`
      },
      active: true,
      orderPlace: 74,
    },
    {
      id: 'GlassEnergy',
      condition: `true`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Glass Energy: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.glassEnergy1`
      },
      active: true,
      orderPlace: 75,
    },
    {
      id: 'NeatGlass',
      condition: `true`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Neat glass: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.neatGlass1`
      },
      active: true,
      orderPlace: 76,
    },
    {
      id: 'GlassStrength',
      condition: `true`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Glass strength: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.glassStrength1`
      },
      active: true,
      orderPlace: 77,
    },
    {
      id: 'GlassThickness',
      condition: `true`,
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Glass thickness: <<name>> </span>`,
      expressions: {
        name: `doorData.glass.glassThickness1`
      },
      active: true,
      orderPlace: 78,
    },    
    {
      id: `ExteriorDoor`,
      descr: `Exterior Window`,
      condition: `doorData && (doorData.finish.exteriorColor.label !== 'White')`,
      template: `<span style="font-size:14px;">✔ Window Exterior: <<name>></span>`,
      expressions: {
        name: `doorData.finish.exteriorColor.label`,
      },
      active: true, orderPlace: 100,
    },

    { 
      id: `InteriorDoor`,
      descr: `Interior Window`,
      condition: `doorData && (doorData.finish.interiorColor.label !== 'White')`,
      template: `<span style="font-size:14px;">✔ Window Interior: <<name>></span>`,
      expressions: {
        name: `doorData.finish.interiorColor.label`,
      },
      active: true, orderPlace: 101,
    },    
    {
      id: `GrillsExterior`,
      descr: `Grills Exterior`,
      condition: `doorData && (doorData.grills.exteriorFinish.label !== 'white')`,
      template: `<span style="font-size:14px;">✔ Grills Exterior: <<name>></span>`,
      expressions: {
        name: `doorData.grills.exteriorFinish.label`,
      },
      active: true, orderPlace: 104,
    },

    { 
      id: `GrillsInterior`,
      descr: `Grills Interior`,
      condition: `doorData && (doorData.grills.interiorFinish.label !== 'white')`,
      template: `<span style="font-size:14px;">✔ Grills Interior: <<name>></span>`,
      expressions: {
        name: `doorData.grills.interiorFinish.label`,
      },
      active: true, orderPlace: 105,
    },
    {
      id: 'Installation',
      condition: `doorData.installation.installationType !== "None"`, // No condition
      template: `<span style="font-size:14px;">✔  <b>Installation</b>:</span>`,
      expressions: {
        name: `doorData.frameData.name`
      },
      active: true,
      orderPlace: 170,
    },
    {
      id: 'InstallationType',
      condition: `doorData.installation.installationType !== "None"`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Type:<<name>></span>`,
      expressions: {
        name: `doorData.installation.installationType`
      },
      active: true,
      orderPlace: 171,
    },
    {
      id: 'brickmoldSize',
      condition: `doorData.installation.installationType !== "None" && 
                  doorData.installation.brickmoldSize !== "None"`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • Brickmold Size: <<name>></span>`,
      expressions: {
        name: `doorData.installation.brickmoldSize`
      },
      active: true,
      orderPlace: 172,
    },
    {
      id: 'jambType',
      condition: `doorData.installation.installationType !== "None" && 
                  doorData.installation.jambType !== "None"`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • jamb Type:<<name>></span>`,
      expressions: {
        name: `doorData.installation.jambType`
      },
      active: true,
      orderPlace: 173,
    },
    {
      id: 'interiorCasing',
      condition: `doorData.installation.installationType !== "None" && 
                  doorData.installation.interiorCasing !== "None"`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • interior Casing: <<name>></span>`,
      expressions: {
        name: `doorData.installation.interiorCasing`
      },
      active: true,
      orderPlace: 174,
    },
    {
      id: 'interiorCasingSize',
      condition: `doorData.installation.installationType !== "None" && 
                  doorData.installation.interiorCasing !== "None" &&
                  doorData.installation.interiorCasingSize !== "None"`, // No condition
      template: `<span style="font-size:14px;">&nbsp;&nbsp; • interior Casing Size:<<name>></span>`,
      expressions: {
        name: `doorData.installation.interiorCasingSize`
      },
      active: true,
      orderPlace: 175,
    },

];
  
  export default templates;
  